import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../redux/auth/auth.slice';
import titleReducer from '../redux/title/title.slice';
import menuReducer from '../redux/menu/menu.slice';
import mddReducer from '../redux/mdd/mdd.slice';
import fundReducer from '../redux/fund/fund.slice';
import fundFilterReducer from '../redux/fundFilter/fundFilter.slice';
import guidanceToolDataReducer from '../redux/guidance/guidanceToolData.slice';
import taxFreeDataReducer from '../redux/taxFree/taxFreeData.slice';
import vehicleReducer from '../redux/vehicle/vehicle.slice';
import alertReducer from '../redux/alert/alert.slice';
import stepperReducer from '../redux/guidance/stepper.slice';
import advisorProfileReducer from '../redux/advisor/advisor.slice';
import clientsReducer from '../redux/clients/clients.slice';
import myAccountReducer from '../redux/myAccount/myAccounts.slice';
import formSliceReducer from '../redux/form/form.slice';
import providersReducer from '../redux/providers/providers.slice';
import reportReducer from '../redux/reports/report.slice';
import aumReducer from '../redux/aum/aum.slice';
import businessDayReducer from '../redux/businessDay/businessDay.slice';
import navMenuReducer from '../redux/navMenu/nav.menu.slice';
import portfolioOverviewReducer from '../redux/portfolioOverview/portfolioOverview.slice';

import { loadState, saveState } from './statePreloader';
const preloadedState = loadState();

const store = configureStore({
  reducer: {
    auth: authReducer,
    title: titleReducer,
    menu: menuReducer,
    mdd: mddReducer,
    fund: fundReducer,
    fundFilter: fundFilterReducer,
    guidanceTool: guidanceToolDataReducer,
    taxFreeData: taxFreeDataReducer,
    vehicle: vehicleReducer,
    alert: alertReducer,
    stepper: stepperReducer,
    advisor: advisorProfileReducer,
    clients: clientsReducer,
    form: formSliceReducer,
    myAccounts: myAccountReducer,
    providers: providersReducer,
    report: reportReducer,
    aum: aumReducer,
    businessDay: businessDayReducer,
    navMenu: navMenuReducer,
    portfolioOverview: portfolioOverviewReducer
  },
  preloadedState
});

store.subscribe(() => {
  saveState(store.getState());
});

export default store;
